import script from "./ItemList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemList.vue?vue&type=script&setup=true&lang=ts"

import "./ItemList.vue?vue&type=style&index=0&id=20c178d2&lang=scss"

const __exports__ = script;

export default __exports__